module.exports = __webpack_public_path__ + "static/media/mpayReward.45650f44.png";